import { KeyValue } from "../types/common";
import {
  getBuildEnvVar,
  getRuntimeVariables,
  getSiteProps,
} from "../utils/siteProps";

const HOME = "/home";
const THOR = "/thor";
const RAVEN = "/raven";
const RAVEN_ML = "/raven_ml";
const FALCON = "/falcon";
const ROBIN = "/robin";
const TREX = "/trex";
const RIO = "/rio";
const PENGUIN = "/penguin";
const RESUME_BUILDER = "/resume-builder";
const SEEKER_PROFILE = "/seeker-profile";
const AB_MODULE = "/ab-module";
const HOME_API_PATH = `${HOME}/api`;
const THOR_API_PATH = `${THOR}/api`;
const RAVEN_API_PATH = `${RAVEN}/api`;
const RAVEN_ML_API_PATH = `${RAVEN_ML}/api`;
const FALCON_API_PATH = `${FALCON}/api`;
const ROBIN_API_PATH = `${ROBIN}/api`;
const RIO_API_PATH = `${RIO}/api`;
const AB_TEST_API_PATH = `${AB_MODULE}/api`;
const PENGUIN_API_PATH = `${PENGUIN}/api`;
const RESUME_BUILDER_API_PATH = `${RESUME_BUILDER}/api`;
export const SEEKER_PROFILE_API_PATH = `${SEEKER_PROFILE}/api`;
const SEEKER_PROFILE_MEDIA_API_PATH = `/public/v2/seeker/public`;
const showOldLogosOnDomains = ["monster.com.vn", "monster.co.th"];

const ROBINPATH: KeyValue = {
  prod: "https://backendservices.monsterindia.com/robin",
  rfs: "https://rfs.monsterindia.com/robin",
  qa1: "https://qa1.monsterindia.com/robin",
};

const REXADMINPATH: KeyValue = {
  prod: "https://rexadmin-prod.monsterindia.com",
  rfs: "https://rexadmin-rfs.monsterindia.com",
  qa1: "https://rexadmin-qa1.monsterindia.com",
};

export const FB_APP_ID = "2202822979737806";
export const FB_APP_IDS = {
  IN: "2202822979737806",
  SA: "776627922732996",
  HK: "2402443739779164",
  SG: "2321740241404008",
  PH: "422628918571957",
  TH: "434863447348842",
  VN: "629624047504556",
  ID: "301538607398265",
  MY: "688558738251762",
};

export const GOOGLE_CLIENT_ID =
  "591528984509-5odtn52njfsg44lqftrpnv0pudm9u8kc.apps.googleusercontent.com";

export const getRecaptchaSiteKey = (host: string | null) => {
  return getBuildEnvVar(host) === "prod"
    ? "6LeZIWUrAAAAABfFKQpT9l4iQjDzOlsko28e6Udl"
    : "6Lf0G2UrAAAAAIerLP7SUUqeTkmhluBqEmsak3cV";
};

export const getRecaptchaSiteKeyForDownloadApp = (host: string | null) => {
  return getBuildEnvVar(host) === "prod"
    ? "6LeuGSUhAAAAAKiK6I9_FZACtkFie7leULAo6Fvh"
    : "6LeGHCUhAAAAAOxkNuE-vVnNz4nCXAmlqDg0QCR3";
};
export const API_ENDPOINT = (host: string, eventName?: "triumph") => {
  const siteProps = getSiteProps(host);
  const env: string = getRuntimeVariables(host);
  const apiUrl = siteProps?.api_url;
  const apiUrl_t_1 = siteProps?.api_t_1;
  const apiUrl_t_2 = siteProps?.api_t_2;
  const apiUrl_t_3 = siteProps?.api_t_3;
  const mediaUrl = siteProps?.media_url;
  const domain = siteProps?.domain || "foundit.in";
  const siteMap = siteProps?.site_map;
  const apiUrlRaven = apiUrl?.includes("www")
    ? "https://apiv3.monsterindia.com"
    : apiUrl?.includes("qa2")
      ? `https://qa1.${siteProps?.domain}`
      : apiUrl;

  const apiVersions = {
    default: {
      validateProfile: "v9",
      workExperience: "v6",
      employmentDetails: "v5",
      jobPreferences: "v8",
      educationDetails: "v4",
    },
    triumph: {
      validateProfile: "v8",
      workExperience: "v3",
      employmentDetails: "v2",
      jobPreferences: "v6",
      educationDetails: "v2",
    },
  };

  const BANNER_PATH: KeyValue = {
    prod: "https://cms.foundit.in",
    rfs: "https://cms-rfs.foundit.in",
    qa1: "https://cms-qa.foundit.in",
  };

  const apiVersionsMap = eventName
    ? apiVersions[eventName]
    : apiVersions.default;

  return {
    penguinAPI: {
      eventPublish: `${apiUrl_t_2}${PENGUIN_API_PATH}/public/events/spltag/v1/publish`,
    },
    homeApi: {
      userDetails: `${apiUrl}${HOME_API_PATH}/userdetails`,
      splashs: `${apiUrl}${HOME_API_PATH}/splash`,
      download: `${apiUrl}${HOME_API_PATH}/downloadApp`,
      getUserJobInfo: `${apiUrl}${HOME_API_PATH}/userJobInfo`,
    },
    robinApi: {
      prepAIQuestions: `${apiUrl_t_1}${ROBIN_API_PATH}/public/v1/prep-ai/ingress-questions`,
    },
    thorApi: {
      cmsData: (category: string) => {
        return {
          headerLinks: `${apiUrl}${THOR_API_PATH}/public/sites/v1/load-module?site=${siteMap}&tenant=reactcore&category=${category}&lang=en&domain=${domain}&subalias=MODULE_HEADER_MSITE_REACT_SSR&alias=HOOK_HEADER`,
          hamburgerLinks: `${apiUrl}${THOR_API_PATH}/public/sites/v1/load-module?site=${siteMap}&tenant=reactcore&category=${category}&lang=en&domain=${domain}&alias=HOOK_HEADER`,
          bannerList: `${apiUrl}${THOR_API_PATH}/public/sites/v1/load-module?site=${siteMap}&tenant=reactcore&category=${category}&lang=en&domain=${domain}&subalias=MODULE_HOME_PRODUCT_BANNER&alias=HOOK_BODY_SECTION`,
          categoryList: `${apiUrl}${THOR_API_PATH}/public/sites/v1/load-module?site=${siteMap}&tenant=reactcore&category=${category}&lang=en&domain=${domain}&subalias=MODULE_HOME_POPULAR_CATEGORY&alias=HOOK_BODY_SECTION`,
          featuredCompanies: `${apiUrl}${THOR_API_PATH}/public/sites/v1/load-module?site=${siteMap}&tenant=reactcore&category=${category}&lang=en&domain=${domain}&subalias=MODULE_HOME_FEATURED_COMPANY&alias=HOOK_BODY_SECTION`,
          footerLinks: `${apiUrl}${THOR_API_PATH}/public/sites/v1/load-module?site=${siteMap}&tenant=reactcore&category=${category}&lang=en&domain=${domain}&alias=HOOK_FOOTER`,
          internalAd: `${apiUrl}${THOR_API_PATH}/public/sites/v1/load-module?site=${siteMap}&tenant=reactcore&category=${category}&lang=en&domain=${domain}&subalias=MODULE_HOME_INTERNAL_ADVERTISEMENT&alias=HOOK_BODY_SECTION`,
          layoutOrder: `${apiUrl}${THOR_API_PATH}/public/sites/v1/load-module?site=${siteMap}&tenant=reactcore&category=${category}&lang=en&domain=${domain}&alias=HOOK_BODY_SECTION`,
          themeCategory: `${apiUrl}${THOR_API_PATH}/public/sites/v1/theme-category-data?site=${siteMap}&tenant=reactcore&category=${category}&lang=en&domain=${domain}`,
          privacyNotice: `${apiUrl}${THOR_API_PATH}/public/sites/v1/pages?site=${siteMap}&tenant=reactcore&category=${category}&lang=en&domain=${domain}&page=MODULE_PRIVACY_NOTICE`,
        };
      },
      downloadApp: `${apiUrl}${THOR_API_PATH}/public/apps/v1/download-link`,
    },
    ravenApi: {
      masterData: `${apiUrl}${RAVEN_API_PATH}/public/search/v1/master-data`,
      suggestedKeywords: `${apiUrl}${RAVEN_API_PATH}/public/search/v1/suggested-keywords`,
      autoFill: `${apiUrlRaven}${RAVEN_API_PATH}/public/search/v1/auto-fill?appName=rex-ui`,
      topLocationsUrl: `${apiUrlRaven}${RAVEN_API_PATH}/public/search/v1/popular-cities?siteContext=${siteMap}`,
      similarJobs: `${apiUrlRaven}${RAVEN_ML_API_PATH}/public/search/v2/ml/similar-jobs`,
      getJobDetails: `${apiUrlRaven}${RAVEN_API_PATH}/public/search/v2/job-detail`,
      getApplyReplyCompanyDetails: `${apiUrlRaven}${RAVEN_API_PATH}/public/search/v1/companies`,
    },
    trexApi: {
      trexMe: `${apiUrl}${TREX}/users/v1/me`,
      sitePropsUrl: `${apiUrl}${TREX}/fetch/msite/en/home-msite`,
      profileStatsUrl: `${apiUrl}${TREX}/users/v3/profile-stats`,
      cart: `${apiUrl}${TREX}/career-services/api/v1/getCartCount`,
    },
    rioApi: {
      anonymousSendOtp: `${apiUrl}${RIO_API_PATH}/public/anonymous-users/v2/send-otp`,
      anonymousVerifyOtp: `${apiUrl}${RIO_API_PATH}/public/anonymous-users/v1/validate-otp`,
      rioMe: `${apiUrl_t_1}${RIO_API_PATH}/users/v1/me`,
      sendOTP: `${apiUrl_t_1}${RIO_API_PATH}/public/users/v5/send-otp`,
      sendOTPV4: `${apiUrl_t_1}${RIO_API_PATH}/public/users/v4/send-otp`,
      saveContact: `${apiUrl_t_1}${RIO_API_PATH}/users/v2/save-contact`,
      verifyOTP: `${apiUrl_t_1}${RIO_API_PATH}/users/v1/vaidate-mobile-detail`,
      sendEmailOTP: `${apiUrl_t_1}${RIO_API_PATH}/users/v1/send-email-otp`,
      verifyEmailOTP: `${apiUrl_t_1}${RIO_API_PATH}/users/v1/vaidate-email-detail`,
      validateSocial: `${apiUrl}${RIO_API_PATH}/public/social/users/v1/validate`,
      doAutoLogin: `${apiUrl}${RIO_API_PATH}/public/users/v1/login`,
      changePassword: `${apiUrl}${RIO_API_PATH}/users/v1/change-password`,
      userUrl: `${apiUrl}${RIO_API_PATH}/users/v1/me`,
      socialLink: `${apiUrl}${RIO_API_PATH}/users/v1/social/link`,
      socialUnLink: `${apiUrl}${RIO_API_PATH}/users/v1/social/unlink`,
      logIn: `${apiUrl}${RIO_API_PATH}/public/users/v1/login-with-redirect`,
    },
    falconApi: {
      // HEADER API
      profileDetails: `${apiUrl_t_1}${FALCON_API_PATH}/users/v9/me/profiles`,
      chatCount: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/rec/count`,
      noticationCountUrl: `${apiUrl_t_1}${FALCON_API_PATH}/users/v3/notification/count`,
      getRecentSearchUrl: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/recent-searches-location`,
      postRecentSearchUrl: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/recent-searches`,
      getApplyReplyDetails: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/apply-reply/fetch`,
      applyReplyAttachResume: `${apiUrl_t_1}${FALCON_API_PATH}/public/users/v1/upload-resume`,

      emailPreferences: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/email-preferences`,
      whatsappOptIn: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/whatsapp-opt-in`,
      deactivateUser: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/deactivate-user`,
      userProfileVisibilityUrl: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/user-profile-visibility`,
      userContactVisibilityUrl: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/profile-visibility`,
      // L1 APOP API
      autoApply: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/update/auto-apply`,
      validateProfile: `${apiUrl_t_1}${FALCON_API_PATH}/users/${apiVersionsMap.validateProfile}/validate/profile`,
      workExperience: `${apiUrl_t_1}${FALCON_API_PATH}/public/users/${apiVersionsMap.workExperience}/work-experience`,
      employmentDetails: `${apiUrl_t_1}${FALCON_API_PATH}/users/${apiVersionsMap.employmentDetails}/employment-details`,
      jobPreferences: `${apiUrl_t_1}${FALCON_API_PATH}/users/${apiVersionsMap.jobPreferences}/job-preferences`,
      educationDetails: `${apiUrl_t_1}${FALCON_API_PATH}/users/${apiVersionsMap.educationDetails}/education-details`,
      lgbtqDisability: `${apiUrl_t_1}${FALCON_API_PATH}/users/v3/LGBTQ-disability`,
      // PROFILE NUDGE API
      nextNudge: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/profile/next-nudge`,
      updateEmploymentDetails: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/employment-details`,
      updateResumeEmployment: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/resume-employment/update`,
      employmentDetailsProfileNudge: `${apiUrl_t_1}${FALCON_API_PATH}/users/v6/employment-details`,
      // REGISTRATION API
      checkEmailExistence: `${apiUrl_t_1}${FALCON_API_PATH}/public/users/v1/check-email-existence-v4`,
      checkNumberExistence: `${apiUrl_t_1}${FALCON_API_PATH}/public/users/v1/check-mobile-number-existence-v4`,
      addDetails: `${apiUrl_t_1}${FALCON_API_PATH}/public/users/register/new-flow/v1/add-details`,
      getRecommendedJobs: `${apiUrl_t_1}${FALCON_API_PATH}/users/v6/ml/jobs/suggested`,
      updateDetails: `${apiUrl_t_1}${FALCON_API_PATH}/public/users/register/new-flow/v1/update-details`,
      updateProfileEducationDetails: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/education-details`,
      updateProfileEmploymentDetails: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/employment-details`,
      nextAction: `${apiUrl_t_1}${FALCON_API_PATH}/conv/next-step`,
      // JOB API
      saveJob: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/jobs/save`,
      savedJob: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/jobs/saved`,
      unsaveJob: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/jobs/unsave`,
      applyJob: `${apiUrl_t_1}${FALCON_API_PATH}/users/v9/jobs/apply`,
      generateDefualtResume: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/preview-resume`,
      // PROFILE API
      awards: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/awards`,
      projects: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/projects`,
      languages: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/personal-details/languages`,
      languagesDelete: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/personal-details/languages`,
      certifications: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/course-and-certification`,
      employment: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/employment-details`,
      education: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/education-details`,
      personal: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/personal-details`,
      preference: `${apiUrl_t_1}${FALCON_API_PATH}/users/v5/job-preferences`,
      socialPresenceV1: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/social-presence`, // Only used for delete
      socialPresenceV2: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/social-presence`,
      workSample: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/work-sample`,
      linkedinConsent: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/linkedin-consent`,
      linkedinConsentV2: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/linkedin-consent`,
      uploadAvatar: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/me/upload-avatar`,
      downloadResume: `${apiUrl_t_1}${FALCON_API_PATH}/public/users/v1/download-resume`,
      removeResume: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/remove-resume`,
      importProfile: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/import-profile`,
      skill: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/skills-and-it-skills`,
      profileFieldsUrl: `${apiUrl_t_1}${FALCON_API_PATH}/users/v7/me/profiles`,
      loadResume: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/me/upload-resume`,
      // DASHBOARD
      applicationHistory: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/application-history`,
      appliedJobs: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/jobs/applied`,
      getAutoApply: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/update/auto-apply`,
      autoApplyNew: `${apiUrl_t_1}${FALCON_API_PATH}/users/v3/update/auto-apply`,
      categorizedJobs: `${apiUrl_t_1}${FALCON_API_PATH}/users/v3/ml/jobs/categorized`,
      notificationApply: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/apply-reply/apply`,
      notificationReply: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/apply-reply/reply`,
      company: {
        block: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/block-companies`,
        unblock: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/unblock-company`,
        blockedCompanyListUrl: `${apiUrl_t_1}${FALCON_API_PATH}/users/v2/blocked-companies`,
      },
      resumeParserStatus: `${apiUrl_t_1}${FALCON_API_PATH}/public/users/v1/is-resume-parsed`,
      updateSalary: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/update-employment-salary`,
      // OUTREACH SUBSCRIPTION
      getOutreachSubscription: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/outreach/subscription`,
      updateOutreachSubscription: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/outreach/subscription/update`,
      // PROFILE PERFORMANCE API
      getActivityLevel: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/profile-performance/activity-level`,
      getSearchAppearances: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/profile-performance/search-appearances`,
      getRecruiterActions: `${apiUrl_t_1}${FALCON_API_PATH}/users/v1/profile-performance/recruiter-actions`,
    },
    abTest: {
      resolveABVariant: `${apiUrl_t_1}${AB_TEST_API_PATH}/public/v1/resolve-variant`,
    },
    rexAdminApi: {
      splashScreen: `${REXADMINPATH[env]}/api/public/mobiles/web/configs/v1/splash-screen`,
    },
    resumeBuilder: {
      attachDefaultResume: `${apiUrl_t_3}${RESUME_BUILDER_API_PATH}/v1/attach-resume`,
      setSummary: `${apiUrl_t_3}${RESUME_BUILDER_API_PATH}/ai/summary/v1/profile-summary`,
      getAiSummaryRequestId: `${apiUrl_t_3}${RESUME_BUILDER_API_PATH}/v1/resume-section/ai-summary`,
      getAiSummary: `${apiUrl_t_3}${RESUME_BUILDER_API_PATH}/ai/summary/v1/fetch`,
      resumeData: `${apiUrl}${RESUME_BUILDER_API_PATH}/v1/resume-data`,
      resumeList: `${apiUrl}${RESUME_BUILDER_API_PATH}/v1/resume-list-all`,
    },
    indianRollerApi: {
      attachResume: `${apiUrl_t_1}/indianroller/api/v2/seeker/profileupdate`,
      parsedResumeData: `${apiUrl_t_1}/indianroller/api/v1/resume/profile/data`,
      isResumeParsed: `${apiUrl_t_1}/indianroller/api/public/users/v1/is-resume-parsed`,
    },
    media: {
      founditLogo: `https://${mediaUrl}/public/core/images/${showOldLogosOnDomains.includes(domain.slice(4)) ? "monsterLogo" : "founditLogo"}-primary.png`,
      founditWhiteLogo: `https://${mediaUrl}/public/core/images/${showOldLogosOnDomains.includes(domain.slice(4)) ? "monsterLogo" : "founditLogo"}-white.png`,
      cmsBannerEnv: `${BANNER_PATH[env]}/api/banners`,
      rocketNudge: `${mediaUrl}${SEEKER_PROFILE_MEDIA_API_PATH}/dashboard/rocketnNudge.png`,
      noResultIcon: `${mediaUrl}${SEEKER_PROFILE_MEDIA_API_PATH}/dashboard/noResulsJobPageDesktop.png`,
      jobRecommendationGif: `${mediaUrl}${SEEKER_PROFILE_MEDIA_API_PATH}/gifs/loadingJRs.gif`,
      jobAppliedSuccessGif: `${mediaUrl}${SEEKER_PROFILE_MEDIA_API_PATH}/gifs/appliedSuccesfully.gif`,
      folderGif: `${mediaUrl}${SEEKER_PROFILE_MEDIA_API_PATH}/gifs/folder.gif`,
      superHeroGif: `https://${mediaUrl}${SEEKER_PROFILE_MEDIA_API_PATH}/gifs/superHero.gif`,
      backgroundUnsubscribeDesign: `https://media.foundit.in/trex/search/public/images/backgroundUnsubscribePageDesign.png`,
    },
    middleware: {
      profileDetails: `${SEEKER_PROFILE_API_PATH}/profileDetails`,
      awards: `${SEEKER_PROFILE_API_PATH}/awards`,
      educations: `${SEEKER_PROFILE_API_PATH}/educationDetailsProfile`,
      projects: `${SEEKER_PROFILE_API_PATH}/projects`,
      languages: `${SEEKER_PROFILE_API_PATH}/languages`,
      certifications: `${SEEKER_PROFILE_API_PATH}/certifications`,
      employmentDetails: `${SEEKER_PROFILE_API_PATH}/employmentDetailsProfile`,
      preference: `${SEEKER_PROFILE_API_PATH}/preferenceDetailsProfile`,
      personalDetails: `${SEEKER_PROFILE_API_PATH}/personalDetailsProfile`,
      setSummary: `${SEEKER_PROFILE_API_PATH}/setProfileSummary`,
      getAiSummaryRequestId: `${SEEKER_PROFILE_API_PATH}/getAiSummaryRequestId`,
      getAiSummary: `${SEEKER_PROFILE_API_PATH}/getAiSummary`,
      uploadResume: `${SEEKER_PROFILE_API_PATH}/attachResume`,
      updateAutoApply: `${SEEKER_PROFILE_API_PATH}/autoApply`,
      downloadResume: `${SEEKER_PROFILE_API_PATH}/downloadResume`,
      removeResume: `${SEEKER_PROFILE_API_PATH}/removeResume`,
      socialPresence: `${SEEKER_PROFILE_API_PATH}/socialPresence`,
      workSample: `${SEEKER_PROFILE_API_PATH}/workSample`,
      linkedinConsentV2: `${SEEKER_PROFILE_API_PATH}/linkedinConsentV2`,
      linkedinConsent: `${SEEKER_PROFILE_API_PATH}/linkedinConsent`,
      sendMobileOTP: `${SEEKER_PROFILE_API_PATH}/getMobileOTP`,
      getMobileOTPV4: `${SEEKER_PROFILE_API_PATH}/getMobileOTPV4`,
      saveContact: `${SEEKER_PROFILE_API_PATH}/saveContact`,
      verifyMobileOTP: `${SEEKER_PROFILE_API_PATH}/verifyMobileOTP`,
      sendEmailOTP: `${SEEKER_PROFILE_API_PATH}/getEmailOTP`,
      verifyEmailOTP: `${SEEKER_PROFILE_API_PATH}/verifyEmailOTP`,
      uploadAvatar: `${SEEKER_PROFILE_API_PATH}/uploadAvatar`,
      validateProfile: `${SEEKER_PROFILE_API_PATH}/validateProfile`,
      getAppliedJobData: `${SEEKER_PROFILE_API_PATH}/getAppliedJobData`,
      getRecommendedJobs: `${SEEKER_PROFILE_API_PATH}/getRecommendedJobs`,
      getJobStatus: `${SEEKER_PROFILE_API_PATH}/getJobStatus`,
      getSimilarJobs: `${SEEKER_PROFILE_API_PATH}/getSimilarJobs`,
      getAutoApply: `${SEEKER_PROFILE_API_PATH}/getAutoApply`,
      suggestedKeywords: `${SEEKER_PROFILE_API_PATH}/suggestedKeywords`,
      skill: `${SEEKER_PROFILE_API_PATH}/skill`,
      profileStats: `${SEEKER_PROFILE_API_PATH}/profileStats`,
      getJobDetails: `${SEEKER_PROFILE_API_PATH}/getJobDetails`,
      emailPreferences: `${SEEKER_PROFILE_API_PATH}/emailPreferences`,
      jobSaveUnsaveAPI: `${SEEKER_PROFILE_API_PATH}/jobSaveUnsave`,
      getPrepAIQuestions: `${SEEKER_PROFILE_API_PATH}/getPrepAIQuestions`,
      getCategorizedJobs: `${SEEKER_PROFILE_API_PATH}/getCategorizedJobs`,
      getUserJobInfo: `${SEEKER_PROFILE_API_PATH}/getUserJobInfo`,
      publishEvents: `${SEEKER_PROFILE_API_PATH}/publishEvents`,
      resolveABVariant: `${SEEKER_PROFILE_API_PATH}/resolveABVariant`,

      masterDataMiddleware: `${SEEKER_PROFILE_API_PATH}/getMasterData`,
      validateProfileMiddleware: `${SEEKER_PROFILE_API_PATH}/validateProfile`,
      workExperienceMiddleware: `${SEEKER_PROFILE_API_PATH}/workExperience`,
      employmentDetailsMiddleware: `${SEEKER_PROFILE_API_PATH}/employmentDetails`,
      jobPreferencesMiddleware: `${SEEKER_PROFILE_API_PATH}/jobPreferences`,
      educationDetailsMiddleware: `${SEEKER_PROFILE_API_PATH}/educationDetails`,
      sendOTPMiddleware: `${SEEKER_PROFILE_API_PATH}/getMobileOTP`,
      anonymousSendOtp: `${SEEKER_PROFILE_API_PATH}/anonymousSendOtp`,
      anonymousVerifyOtp: `${SEEKER_PROFILE_API_PATH}/anonymousVerifyOtp`,
      verifyOTPMiddleware: `${SEEKER_PROFILE_API_PATH}/verifyMobileOTP`,
      sendEmailOTPMiddleware: `${SEEKER_PROFILE_API_PATH}/getEmailOTP`,
      verifyEmailOTPMiddleware: `${SEEKER_PROFILE_API_PATH}/verifyEmailOTP`,
      sitePropsMiddleware: `${SEEKER_PROFILE_API_PATH}/getSiteProps`,
      splash: `${SEEKER_PROFILE_API_PATH}/splash`,
      autoApply: `${SEEKER_PROFILE_API_PATH}/autoApply`,
      attachResumeMiddleware: `${SEEKER_PROFILE_API_PATH}/attachResume`,
      validateSocial: `${SEEKER_PROFILE_API_PATH}/validateSocial`,
      checkEmailExistence: `${SEEKER_PROFILE_API_PATH}/checkEmailExistence`,
      checkNumberExistence: `${SEEKER_PROFILE_API_PATH}/checkNumberExistence`,
      doAutoLogin: `${SEEKER_PROFILE_API_PATH}/doAutoLogin`,
      loginWithRedirect: `${SEEKER_PROFILE_API_PATH}/loginWithRedirect`,
      addDetails: `${SEEKER_PROFILE_API_PATH}/addDetails`,
      updateDetails: `${SEEKER_PROFILE_API_PATH}/updateDetails`,
      updateProfileEducationDetails: `${SEEKER_PROFILE_API_PATH}/updateProfileEducationDetails`,
      updateProfileEmploymentDetails: `${SEEKER_PROFILE_API_PATH}/updateProfileEmploymentDetails`,
      nextAction: `${SEEKER_PROFILE_API_PATH}/nextAction`,
      jobSaveUnsave: `${SEEKER_PROFILE_API_PATH}/jobSaveUnsave`,
      applyJob: `${SEEKER_PROFILE_API_PATH}/applyJob`,
      generateDefaultResume: `${SEEKER_PROFILE_API_PATH}/generateDefaultResume`,
      attachDefaultResume: `${SEEKER_PROFILE_API_PATH}/attachDefaultResume`,
      whatsappOptIn: `${SEEKER_PROFILE_API_PATH}/whatsappOptIn`,
      changePassword: `${SEEKER_PROFILE_API_PATH}/changePassword`,
      userUrl: `${SEEKER_PROFILE_API_PATH}/userUrl`,
      socialLink: `${SEEKER_PROFILE_API_PATH}/socialLink`,
      socialUnLink: `${SEEKER_PROFILE_API_PATH}/socialUnLink`,
      deactivateUser: `${SEEKER_PROFILE_API_PATH}/deactivateUser`,
      userProfileVisibilityUrl: `${SEEKER_PROFILE_API_PATH}/userProfileVisibilityUrl`,
      userContactVisibilityUrl: `${SEEKER_PROFILE_API_PATH}/userContactVisibilityUrl`,
      blockedCompanyListUrl: `${SEEKER_PROFILE_API_PATH}/blockedCompanyListUrl`,
      block: `${SEEKER_PROFILE_API_PATH}/block`,
      unblock: `${SEEKER_PROFILE_API_PATH}/unblock`,
      profileBanner: `${SEEKER_PROFILE_API_PATH}/profileBanner`,
      getMasterData: `${SEEKER_PROFILE_API_PATH}/getMasterData`,
      jobPreferences: `${SEEKER_PROFILE_API_PATH}/jobPreferences`,
      profileFieldsUrl: `${SEEKER_PROFILE_API_PATH}/profileFieldsUrl`,
      loadResume: `${SEEKER_PROFILE_API_PATH}/loadResume`,
      resumeData: `${SEEKER_PROFILE_API_PATH}/resumeData`,
      resumeList: `${SEEKER_PROFILE_API_PATH}/resumeList`,
      userDetails: `${SEEKER_PROFILE_API_PATH}/userDetails`,
      splashs: `${SEEKER_PROFILE_API_PATH}/splashs`,
      download: `${SEEKER_PROFILE_API_PATH}/download`,
      resumeParserStatus: `${SEEKER_PROFILE_API_PATH}/resumeParserStatus`,
      login: `${SEEKER_PROFILE_API_PATH}/login`,
      linkedinAuth: `${SEEKER_PROFILE_API_PATH}/linkedinAuth`,
      updateOutreachSubscription: `${SEEKER_PROFILE_API_PATH}/updateOutreachSubscription`,
      getOutreachSubscription: `${SEEKER_PROFILE_API_PATH}/getOutreachSubscription`,
      activityLevel: `${SEEKER_PROFILE_API_PATH}/activityLevel`,
      searchAppearances: `${SEEKER_PROFILE_API_PATH}/searchAppearances`,
      recruiterActions: `${SEEKER_PROFILE_API_PATH}/recruiterActions`,
      parsedResumeData: `${SEEKER_PROFILE_API_PATH}/parsedResumeData`,
      isResumeParsed: `${SEEKER_PROFILE_API_PATH}/isResumeParsed`,
    },
  };
};

export const LINKEDIN_CLIENT_ID =
  process.env.NEXT_PUBLIC_LINKEDIN_CLIENT_ID || "78t4lx27o45a60";
export const LINKEDIN_CLIENT_SECRET =
  process.env.LINKEDIN_CLIENT_SECRET || "iwjFiT0GYTu1L6gL";
export const LINKEDIN_STATE = process.env.LINKEDIN_STATE || "monsterLinkedIn";
export const LINKEDIN_SCOPE =
  process.env.LINKEDIN_SCOPE || "r_liteprofile%20r_emailaddress";

export const LINKEDIN_OAUTH_URL =
  "https://www.linkedin.com/oauth/v2/authorization?response_type=code";

export const LOGIN_CLIENT_ID = "fd111af2-493d-11e8-9621-24a074f06450";
